<p-confirmDialog />

<div class="space-y-4">
  <!-- Header -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
    <div>
      <h1 class="text-xl font-bold text-gray-900 dark:text-gray-100">
        {{ 'VARIANT_ATTRS.TITLE' | translate }}
      </h1>
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
        {{ 'VARIANT_ATTRS.SUBTITLE' | translate }}
      </p>
    </div>
    <p-button
      [label]="'VARIANT_ATTRS.ADD_BTN' | translate"
      icon="pi pi-plus"
      (onClick)="openCreate()"
    />
  </div>

  <!-- Search -->
  <div class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
    <div class="flex flex-col sm:flex-row gap-3">
      <input
        pInputText
        [(ngModel)]="search"
        [placeholder]="'VARIANT_ATTRS.SEARCH_PLACEHOLDER' | translate"
        class="w-full"
        (keyup.enter)="onSearch()"
      />
      <p-button
        [label]="'COMMON.SEARCH' | translate"
        icon="pi pi-search"
        severity="secondary"
        [loading]="loading()"
        (onClick)="onSearch()"
        styleClass="w-full sm:w-auto"
      />
    </div>
  </div>

  <!-- Table -->
  <div
    class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm overflow-hidden"
  >
    <div class="overflow-x-auto">
      <p-table
        [value]="attributes()"
        [loading]="loading()"
        [paginator]="true"
        [rows]="20"
        [rowsPerPageOptions]="[10, 20, 50]"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [tableStyle]="{ 'min-width': '36rem' }"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="w-8">#</th>
            <th class="w-48">{{ 'VARIANT_ATTRS.COL.NAME' | translate }}</th>
            <th>{{ 'VARIANT_ATTRS.COL.VALUES' | translate }}</th>
            <th class="w-32 text-center">{{ 'VARIANT_ATTRS.COL.ACTIONS' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-attr let-rowIndex="rowIndex">
          <tr>
            <td class="text-gray-400 text-xs">{{ rowIndex + 1 }}</td>
            <td>
              <span class="font-medium text-gray-900 dark:text-gray-100">{{ attr.name }}</span>
            </td>
            <td>
              <div class="flex flex-wrap gap-1">
                @for (v of attr.values; track v.id) {
                  <p-tag [value]="v.value" severity="secondary" />
                } @empty {
                  <span class="text-xs text-gray-400">{{
                    'VARIANT_ATTRS.NO_VALUES' | translate
                  }}</span>
                }
              </div>
            </td>
            <td>
              <div class="flex items-center justify-center gap-1">
                <p-button
                  icon="pi pi-plus"
                  [rounded]="true"
                  [text]="true"
                  severity="secondary"
                  size="small"
                  [pTooltip]="'VARIANT_ATTRS.ADD_VALUE' | translate"
                  tooltipPosition="top"
                  (onClick)="openAddValue(attr)"
                />
                <p-button
                  icon="pi pi-trash"
                  [rounded]="true"
                  [text]="true"
                  severity="danger"
                  size="small"
                  [pTooltip]="'COMMON.DELETE' | translate"
                  tooltipPosition="top"
                  (onClick)="confirmDelete(attr)"
                />
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" class="text-center py-12 text-gray-400">
              <i class="pi pi-sliders-h text-3xl mb-2 block"></i>
              {{ 'VARIANT_ATTRS.EMPTY' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- Create Attribute Dialog -->
<p-dialog
  [(visible)]="createVisible"
  [header]="'VARIANT_ATTRS.CREATE_TITLE' | translate"
  [modal]="true"
  [closable]="true"
  [style]="{ width: 'min(520px, 95vw)' }"
  (onHide)="closeCreate()"
>
  <div class="flex flex-col gap-4 pt-2">
    <div class="flex flex-col gap-1.5">
      <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ 'VARIANT_ATTRS.FORM.NAME' | translate }} <span class="text-red-500">*</span>
      </label>
      <input
        pInputText
        [(ngModel)]="form.name"
        [placeholder]="'VARIANT_ATTRS.FORM.NAME_PLACEHOLDER' | translate"
        class="w-full"
      />
    </div>

    <!-- Do'kon (storeType) — majburiy. Bitta bo'lsa `openCreate()` da o'zi qo'yiladi. -->
    @if (storePick.visible()) {
      <div class="flex flex-col gap-1.5">
        <label for="attr-store" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'VARIANT_ATTRS.FORM.STORE' | translate }} <span class="text-red-500">*</span>
        </label>
        <p-select
          inputId="attr-store"
          [options]="stores()"
          optionLabel="name"
          optionValue="id"
          [placeholder]="'VARIANT_ATTRS.FORM.SELECT_STORE' | translate"
          [(ngModel)]="form.storeId"
          appendTo="body"
          class="w-full"
        />
      </div>
    }

    <div class="flex flex-col gap-2">
      <div class="flex items-center justify-between">
        <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {{ 'VARIANT_ATTRS.FORM.VALUES' | translate }}
        </label>
        <p-button
          [label]="'VARIANT_ATTRS.FORM.ADD_VALUE_ROW' | translate"
          icon="pi pi-plus"
          severity="secondary"
          [text]="true"
          size="small"
          (onClick)="addValueRow()"
        />
      </div>
      @for (row of form.values; track $index) {
        <div class="flex items-center gap-2">
          <input
            pInputText
            [(ngModel)]="row.value"
            [placeholder]="'VARIANT_ATTRS.FORM.VALUE_PLACEHOLDER' | translate"
            class="flex-1"
          />
          <input
            pInputText
            [(ngModel)]="row.extra"
            [placeholder]="'VARIANT_ATTRS.FORM.EXTRA_PLACEHOLDER' | translate"
            class="w-28"
          />
          <p-button
            icon="pi pi-times"
            [rounded]="true"
            [text]="true"
            severity="danger"
            size="small"
            (onClick)="removeValueRow($index)"
          />
        </div>
      }
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        [label]="'COMMON.CANCEL' | translate"
        severity="secondary"
        [text]="true"
        (onClick)="closeCreate()"
      />
      <p-button [label]="'COMMON.CREATE' | translate" [loading]="saving" (onClick)="save()" />
    </div>
  </ng-template>
</p-dialog>

<!-- Add Value Dialog -->
<p-dialog
  [(visible)]="addValueVisible"
  [header]="'VARIANT_ATTRS.ADD_VALUE_TITLE' | translate"
  [modal]="true"
  [closable]="true"
  [style]="{ width: 'min(420px, 95vw)' }"
  (onHide)="closeAddValue()"
>
  <div class="flex flex-col gap-4 pt-2">
    <p class="text-sm text-gray-500 dark:text-gray-400">
      {{ addValueTarget?.name }}
    </p>
    <div class="flex flex-col gap-1.5">
      <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ 'VARIANT_ATTRS.FORM.VALUE' | translate }} <span class="text-red-500">*</span>
      </label>
      <input
        pInputText
        [(ngModel)]="valueForm.value"
        [placeholder]="'VARIANT_ATTRS.FORM.VALUE_PLACEHOLDER' | translate"
        class="w-full"
        (keyup.enter)="saveValue()"
      />
    </div>
    <div class="flex flex-col gap-1.5">
      <label for="" class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ 'VARIANT_ATTRS.FORM.EXTRA' | translate }}
      </label>
      <input
        pInputText
        [(ngModel)]="valueForm.extra"
        [placeholder]="'VARIANT_ATTRS.FORM.EXTRA_PLACEHOLDER' | translate"
        class="w-full"
      />
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        [label]="'COMMON.CANCEL' | translate"
        severity="secondary"
        [text]="true"
        (onClick)="closeAddValue()"
      />
      <p-button
        [label]="'COMMON.ADD' | translate"
        [loading]="addValueSaving"
        (onClick)="saveValue()"
      />
    </div>
  </ng-template>
</p-dialog>
